import React, { useEffect, useState } from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom'; // Import necessary hooks
import { getWithoutTokenAPI } from '../../util/Api'; // Update API function to handle query params
import './Singleblog.css';
import './Blogbanner.css';
import back from '../../assets/left.png';
import { useSelector } from 'react-redux';
import { PiTagLight } from "react-icons/pi";
import { GoComment } from "react-icons/go";
import { FaRegUser } from "react-icons/fa";
// import orange from '../../assets/cartproduct.svg';
import owner from '../../assets/author.png';
import LeaveComment from './Commentsection';
import { FaFacebookF, FaTwitter, FaPinterestP, FaInstagram } from "react-icons/fa";
import Promo from './Promo';
// import CommentsSection from './Review';
import DOMPurify from 'dompurify';
import FilterSidebar from './Filtersidebar';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './Review.css';
const BlogDetail = () => {
  const navigate = useNavigate();
  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const { search } = useLocation(); // To get query parameters
  const token = useSelector((state) => state.auth?.auth?.access_token); // Get token from Redux state

  const queryParams = new URLSearchParams(search); // Parse query params
  const blogId = queryParams.get('_id'); // Extract the blog ID


  useEffect(() => {
    const fetchBlog = async () => {
      if (!blogId) return;
      setLoading(true);
      try {
        const res = await getWithoutTokenAPI(`/blog/find-particular?_id=${blogId}`);
        if (res?.data) {
          setBlogPost(res.data);
        } else {
          console.error("Failed to fetch the blog", res.error);
        }
      } catch (error) {
        console.error("Error fetching the blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [blogId]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!blogPost) {
    return <p>Blog not found.</p>;
  }
  const cleanHTML = DOMPurify.sanitize(blogPost.description, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'b', 'i'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  });

  return (
    <>
      <div className='aligin-button'>
        <div className="button-back" onClick={() => navigate('/blog')}>
          <FaArrowLeft className="back-icon" />
          <button className="back-text">back</button>
        </div>
      </div>

      <div className="blog-detail-layout">
        <FilterSidebar />

        <div className="blog-detail">
          <h1 className="blog-detail__title">{blogPost.title}</h1>
          <h5 className="blog-detail__subtitle">{blogPost.subtitle}</h5>
          <div className="blog-detail__info-row">
            {/* <div className="blog-detail__tag">
              <PiTagLight />
              <span>{blogPost.tags?.[0]?.name || 'Uncategorized'}</span>
            </div> */}
            <div className="blog-detail__admin">
              <FaRegUser />
              <span>{blogPost.author?.name || 'Admin'}</span>
            </div>
            <div className="blog-detail__read-time">
              <span>{blogPost.read_time || 0} min read</span>
            </div>
          </div>
          <img
            src={blogPost.images?.[0]}
            alt={blogPost.title}
            className="blog-detail__image"
          />


          <div className="blog-detail__author-bar">
            <div className="blog-detail__author-info">
              <img
                src={blogPost.author?.profile_image || owner}
                alt={blogPost.author?.name || 'Author'}
              />
              <div>
                <div style={{ fontWeight: '500' }}>
                  By {blogPost.author?.name || 'Admin'}
                </div>
                <div style={{ color: '#999999', fontSize: '14px' }}>
                  Posted on {new Date(blogPost.createdAt).toLocaleDateString()}
                </div>
              </div>
            </div>

            <div className="blog-detail__socials">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className='fb' />
              </a>
              <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
                <FaTwitter className='tw' />
              </a>
              <a href="https://in.pinterest.com/" target="_blank" rel="noopener noreferrer">
                <FaPinterestP className='pintest' />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                <FaInstagram className='insta' />
              </a>
            </div>
          </div>

          {/* <div className="blog-detail__description">
            {blogPost.description}
          </div> */}  
          <div
            className="blog-detail__description"
            dangerouslySetInnerHTML={{ __html: cleanHTML }}
          />

          <div className="blog-detail__tags">
            {blogPost.tags?.map((tag) => (
              <span key={tag._id} className="blog-tag">
                {tag.name}
              </span>
            ))}
          </div>

          {/* <Promo /> */}
          <LeaveComment blogId={blogId} />
          {/* <CommentsSection token={token} blogId={blogId} /> */}
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
